export default __webpack_public_path__ + "static/hom-human-d6ff293d421000ce8aa5944d6a6dc003.svg";